import {
    nFormatter,
    createSeries,
    createSQL,
    seriesHead,
    appendAggregateValues,
    seriesDataItem,
    pickItem,
    isDateTransformation,
    highestModel,
    averageModel,
    missingValuesModel,
    resolve,
    getSeriesColors,
    extractColors
} from "@/components/charts/common";

import { createDataSource } from '@/models/data-source';


export default async function hydrator(parameters, data, chart) {



    try {
        chart.uiUpdate();
    } catch(error) {

    }
}
